<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    海月站<br>
站点介绍<br>
海月站位于南山区后海滨路与工业八路交叉路口的后海滨路下，沿后海滨路南北向布置，西侧有后海大道，北侧为东滨路，南侧是工业七路。东侧宝能太古新城地下商场是这一区域的重要购物圣地，为周边小区提供一站式购物。周边为高档小区，西北侧为招商海月花园，西南侧有天骄华庭等。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:47	00:27	2号线	2分35秒	5分45秒<br>
莲塘	06:03	23:13	2号线	2分35秒	5分45秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:52	00:27	2号线	4分钟	5分钟<br>
莲塘	06:06	23:13	2号线	4分钟	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:52	01:17	2号线	4分钟	5分钟<br>
莲塘	06:06	00:13	2号线	4分钟	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
太古城南区、卓越维港、工商银行、致远大厦、后海停车场、吉祥龙花园、肯德基、华润万家、后海滨路东侧、工业八路南侧、小珂丽格医疗美容<br><br>
B出入口:<br>
太古城北区、深圳湾口岸、三湘海尚、曦湾华府、君汇新天、工业八路北侧<br><br>
C出入口:<br>
后海小学、东滨路、招商海月、海月花园1-2期、工业九路、后海滨路西侧、海月路、北京师范大学南山附属中学、水师附中、蓝月湾畔<br><br>
D出入口:<br>
后海滨路西侧、工业八路南侧、工业七路、爱榕路、公园路、深圳育才三中、育才四小、海月花园3-5期、蛇口沃尔玛、半岛花园、天骄华庭、菜市场、花半里、四海公园<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 海月地铁站公交站<br>
B737、M418、M430、B817<br><br>
C出入口:<br>
公交站名： 海月地铁站2公交站<br>
B737、M430、B817、N27<br><br>
D出入口:<br>
公交站名： 海月地铁站1公交站<br>
M418<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>